import { AfterViewInit, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { filter, take } from 'rxjs';
import { environment } from './../environments/environment';
import { AuthentificationService } from './authentification/authentification.service';
import { LoadingPageService } from './services/loading-page.service';
import { GoogleMapsLoaderService } from './services/google-maps-loader.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewInit {
  notifOptions = {
    showProgressBar: false,
    lastOnBottom: true,
    position: ['top', 'right'],
    timeOut: 15000,
    clickToClose: true,
    preventDuplicates: true,
    maxStack: 2,
  };

  constructor(
    public translate: TranslateService,
    private router: Router,
    public auth: AuthentificationService,
    public loadingService: LoadingPageService,
    private googleMapsLoader: GoogleMapsLoaderService,
  ) {
    translate.setDefaultLang('fr');
    translate.use('fr');
    console.debug(`current version : ${environment.version}`);
    moment.locale('fr');
  }

  private _loading$ = this.loadingService.loading$;

  get loading$() {
    return this._loading$;
  }
  ngAfterViewInit(): void {
    // Load Google Maps API after user is authenticated
    this.auth.canActivateProtectedRoutes$
      .pipe(
        filter(canActivate => canActivate),
        take(1),
      )
      .subscribe(() => {
        this.googleMapsLoader.loadScript().subscribe({
          next: () => console.debug('Google Maps API loaded successfully'),
          error: err => console.error('Failed to load Google Maps API', err),
        });
      });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        document.querySelector('body').scrollTo(0, 0);
      });
  }
}
